import React, { Component } from 'react';
import classNames from 'classnames';
import './Card.css';

export default class Card extends Component {
	render() {
		const otherProps = {}
    	if('tabIndex' in this.props) {
      		otherProps.tabIndex = this.props.tabIndex;
    	}
    	if('onClick' in this.props) {
      		otherProps.tabIndex = "0"
    	}
		return (
			<div
				{...otherProps}
				// tabIndex={this.props.tabIndex || -1}
				onClick={this.props.onClick}
          onBlur={this.props.onBlur}
				className={classNames('g-card', { half: this.props.half }, { inline: this.props.inline }, this.props.className)}
			>
				{this.props.children}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/card/Card.jsx